import React, { FC, useMemo } from 'react';

import { getLocalStorage } from '../../hooks/authentication';
import NameAvatar from '../dataGrid/NameAvatar';

const MyBootAvatar: FC<{ type: string }> = ({ type }) => {
  const user_profile = useMemo(() => getLocalStorage('user_profile'), []);

  if (type === 'user') {
    return (
      <NameAvatar
        firstName={user_profile?.first_name || ''}
        lastName={user_profile?.last_name || ''}
        color="navy"
        style={{ marginLeft: '10px' }}
      />
    );
  } else {
    return (
      <NameAvatar
        firstName="Ultra"
        color="lavender"
        style={{ marginRight: '10px' }}
      />
    );
  }
};
export default MyBootAvatar;
